import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const Input = (props) => {
    const {
        label: {
            text,
            labelClasses,
            wrapperClasses,
            isInputRequired,
            ariaLabel,
        },
        inputField: {
            name,
            inputClasses,
            placeholder,
            type,
            value,
            registeredInputs
        }
    } = props;

    return (
        <Fragment>
            <div className={`grid-row gi-component gi-${type} ${wrapperClasses && wrapperClasses.join(' ')}`}>
                <label
                    htmlFor={name}
                    className={`gi-input__label ${labelClasses && labelClasses.join(' ')} required-${isInputRequired}`}
                    aria-label={ariaLabel}
                >
                    <FormattedMessage id={ text } />
                </label>
                <input
                    id={name}
                    data-automation-id={name}
                    className={inputClasses && inputClasses.join(' ')}
                    name={name}
                    type={type}
                    ref={registeredInputs}
                    placeholder={placeholder}
                    aria-required={isInputRequired}
                    value={value}
                />
            </div>
        </Fragment>
    );
};

export default Input;